// extracted by mini-css-extract-plugin
module.exports = {"logo":"MastheadLink__logo___26Om9"};